class ReportsQuestionsLogs
  constructor: ->
    @_bind()

  _bind: ->
    $el = $('.reports-questions-log-list')
    $el.on 'click', '.link-logs-more', ->
      $el.find('.log-item.hide').removeClass 'hide'
      $(@).remove()

tower.reportsQuestionsLogs = ->
  new ReportsQuestionsLogs
